import { ColumnsType } from "antd/es/table";
import AntTable from "../../../components/table/Table";
import { Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { PaymentService } from "../../../services/PaymentService";
import { useState } from "react";
import Filter from "./Filter";
import EditMember from "./../../member/EditMember";
import moment from "moment";



export default function Transaction() {

    const [isModalOpenUser, setIsModalOpenUser] = useState<boolean>(false);
    const [editRecordUser, setEditRecordUser] = useState<any>()
    const [refreshData, setRefreshData] = useState<boolean>(false)
    const [filters, setFilters] = useState<any>()



    const columns: ColumnsType<any> = [
        {
            title: 'Transaction Date',
            align: 'center',
            dataIndex: 'trx_created_date',
            key: 'trx_created_date',
            render: (value, record) => {
                return moment(value).isValid() ? moment(value).format('DD-MM-YYYY HH:mm') : ''
            },
        },
        {
            title: 'Approval Date',
            align: 'center',
            dataIndex: 'approved_date',
            key: 'approved_date',
            render: (value, record) => {
                return moment(value).isValid() ? moment(value).format('DD-MM-YYYY HH:mm') : ''
            },
        },
        {
            title: 'ICP no.',
            align: 'center',
            dataIndex: 'transaction_id',
            key: 'transaction_id',
            render: (value, record) => {
                return `${value}`
            }
        },
        {
            title: 'Status',
            align: 'center',
            filters: [
                {
                    text: 'Completed',
                    value: "'Completed'",
                },
                {
                    text: 'Processing',
                    value: "'Processing'",
                },
                {
                    text: 'Canceled',
                    value: "'Canceled'",
                },

            ],
            dataIndex: 'transaction_status',
            key: 'transaction_status',
            render: (value, record) => {
                return `${value}`
            }
        },
        {
            title: 'Amount (THB)',
            align: 'center',
            dataIndex: 'send_amount',
            key: 'send_amount',
            render: (value, record) => {
                return  `${(+value).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
            }
        },
        {
            title: 'Amount (MMK)',
            align: 'center',
            dataIndex: 'receive_amount',
            key: 'receive_amount',
            render: (value, record) => {
                return `${(+value).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
            }
        },
        {
            title: 'Fee',
            align: 'center',
            dataIndex: 'fee',
            key: 'fee',
            render: (value, record) => {
                return `${(+value).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
            }
        },
        {
            title: 'Referral Code',
            align: 'center',
            dataIndex: 'ref_code',
            key: 'ref_code',
            render: (value, record) => {
                return value
            }
        },
        {
            title: 'Remitter Name',
            align: 'center',
            dataIndex: 'remiter_name',
            key: 'remiter_name',
            render: (value, record) => {
                return value
            }
        },
        {
            title: 'Remitter Phone Number',
            align: 'center',
            dataIndex: 'remiter_phone_number',
            key: 'remiter_phone_number',
            render: (value, record) => {
                return value
            }
        },
        {
            title: 'Receiver Name',
            align: 'center',
            dataIndex: 'receiver_name',
            key: 'receiver_name',
            render: (value, record) => {
                return value
            }
        },
        {
            title: 'Receiver Phone Number',
            align: 'center',
            dataIndex: 'receiver_phone_number',
            key: 'receiver_phone_number',
            render: (value, record) => {
                return value
            }
        },
        {
            title: 'Transactions Type',
            align: 'center',
            dataIndex: 'transaction_type',
            key: 'transaction_type',
            render: (value, record) => {
                return value
            }
        },
        {
            title: 'Location',
            align: 'center',
            dataIndex: 'location',
            key: 'location',
            render: (value, record) => {
                return value
            }
        },
        {
            title: 'Tax invoice',
            align: 'center',
            dataIndex: 'tax_invoice',
            key: 'tax_invoice',
            render: (value, record) => {
                return value
            }
        },
        {
            title: 'Vat7%',
            align: 'center',
            dataIndex: 'vat',
            key: 'vat',
            render: (value, record) => {
                return `${(+value).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
            }
        },
        {
            title: 'Total Service Fee Including VAT',
            align: 'center',
            dataIndex: 'total_fee',
            key: 'total_fee',
            render: (value, record) => {
                return `${(+value).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
            }
        },
    ];


    const onLoadData = async (params: any = {}) => {

        const payload = {
            ...params,
            ...filters
        }
        const res = await PaymentService.getPaymentTransactions2(payload)
        return res
    }

    const exportReport = async () => {
        const data = {
            month: filters.month,
            year: filters.year
        }
        await PaymentService.exportPaymentTransactions2(data)
    }

    const onFilters = (data: object) => {
        setFilters(data)
        setRefreshData(p => !p)
    }


    return (
        <>

            <Modal
                title=""
                width={900}
                open={isModalOpenUser}
                onOk={() => setIsModalOpenUser(true)}
                onCancel={() => setIsModalOpenUser(false)}
                footer={null}>
                <EditMember
                    record={editRecordUser}
                    onFinish={() => {
                        setIsModalOpenUser(false)
                    }}
                ></EditMember>
            </Modal>
            <AntTable
                Filter={<Filter setFilters={onFilters} />}
                refresh={refreshData}
                menuOptions={[{
                    label: `Export Excel - ${filters?.year && moment().set('month', filters?.month - 1).year(filters?.year).format('MMMM YYYY')}`,
                    key: 'export'
                }]}
                menuClick={(e) => {
                    if (e.key == 'export') {
                        exportReport();
                    }
                }}
                search
                title="Payment Transaction 2"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>

    )
}